import { ButtCon, LoadingOverlay } from "@biom3/react";
import { useEffect, useState } from "react";

type Props = {
  loading: boolean;
  text: string | string[];
  closeable?: boolean;
  loopingText?: boolean;
  cancelLogin?: () => void;
};

export const LoadingModal = ({
  loading,
  text,
  closeable = false,
  loopingText = true,
  cancelLogin,
}: Props) => {
  const [isContentVisible, setIsContentVisible] = useState(false);

  // Handle conditional text display based on loading state and loopingText flag
  const displayText = (() => {
    if (loopingText) {
      // Original behavior: pass array to LoopingText for looping
      return Array.isArray(text) ? text : [text];
    }
    // New behavior: show different text based on loading state
    if (Array.isArray(text)) {
      // If array: show first element when not loading, second when loading
      return [loading ? text[1] || text[0] : text[0]];
    }
    // If string: always show the string
    return [text];
  })();

  useEffect(() => {
    if (loading) {
      setTimeout(() => {
        // Give the browser time to append Passport's embedded login prompt iFrame to the DOM
        // before displaying the LoadingOverlay content
        if (loading) setIsContentVisible(true);
      }, 1000);
    } else {
      setIsContentVisible(false);
    }
  }, [loading]);

  return (
    <LoadingOverlay visible={loading} testId="loading-modal">
      <LoadingOverlay.Content
        sx={{
          alignItems: "center",
          position: "relative",
          visibility: isContentVisible ? "visible" : "hidden",
        }}
      >
        {closeable && (
          <ButtCon
            icon="Close"
            onClick={cancelLogin}
            variant="tertiary"
            size="small"
            testId="loading-modal-close"
            sx={{
              position: "absolute",
              top: "base.spacing.x4",
              right: "base.spacing.x4",
            }}
          />
        )}
        <LoadingOverlay.Content.LoopingText text={displayText} />
      </LoadingOverlay.Content>
    </LoadingOverlay>
  );
};
